module.exports = __webpack_public_path__ + "img/iPhone10_sml-bd9e78fb46ada5b9db7cb967277d7043.png";